module.exports = __webpack_public_path__ + "media/MRI6C.5750b3a5.mp3";